import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import EierIcon from '../../../images/Owners 1_white.png'
import CollapseIcon from '../../../images/collapse copy.png'
import ExpandIcon from '../../../images/expand copy.png'

class Eier extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleEier = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var eier = this.props.eier
        return (
            <li>
                <div className="section-header mainsection" onClick={this.toggleEier}>
                    <div className="icon-image"><img src={EierIcon} /></div>
                    <span className="title">{eier.navn}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                <div className="row">
                        <div className="column">
                            <div className="label">{t('navn')}</div>
                            <div className="value">{eier.navn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{ eier.domeneklasse == "JuridiskPerson" ? t('orgnummer') : t('fodselsnummer')}</div>
                            <div className="value">{eier.nummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('adresse')}</div>
                            <div className="value">{eier.postadresselinje2 || eier.postadresselinje1}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('poststed')}</div>
                            <div className="value">{eier.postadresselinje3}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('personkategori')}</div>
                            <div className="value">{eier.personkategoriKode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('personstatus')}</div>
                            <div className="value">{eier.personstatusKode}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Eier)